<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";

defineProps({
    religions: Array
});
const rutaprefijo = ref('religion');
const modulo = ref('religión');
</script>

<template>

    <Head title="Religiones Config." />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Religiones" subtitle="Gestión de religiones">
        </PremiumPageHeader>
    </template>


        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                <CardBox class="mb-6" has-table>
                    <!-- Tablesingle opciones: checkable -->
                    <TableSingle :modulo="modulo" :data="religions" :ruta="rutaprefijo" />
                </CardBox>
            </div>
        </div>

    </BreezeAuthenticatedLayout>
</template>
